import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CashIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M20 19a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16Zm0-12h-1.7L21 9.7V8c0-.6-.4-1-1-1ZM8.3 7h7.2l4.9 4.9-5.1 5.1H8.5l-5-5.1L8.2 7ZM4 7h1.5L3 9.5V8c0-.6.4-1 1-1Zm-1 9v-1.7L5.7 17H4a1 1 0 0 1-1-1Zm18-1.9L18.1 17H20c.6 0 1-.4 1-1v-1.9Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CashIcon;
